var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-dialog',{ref:"dialog",attrs:{"title":"Modify Pallet","inputs-map":_vm.inputsMap,"input-value-change":_vm.valueChange,"save-cb":_vm.save,"width":50,"reset-inputs":_vm.resetInputs}})
}
var staticRenderFns = []

export { render, staticRenderFns }